import React, { createContext, useReducer } from 'react';
import { Cloud } from 'types/cloud';
import reducer from './reducer';
import { setLoading, getCloud, patchCloud, deleteCloud } from './actions';

export interface CloudDetailState {
  cloud: Cloud;
  updateLoading: boolean;
  errors: any;

  setLoading?(value: boolean): void;
  getCloud?(id: number | string): void;
  deleteCloud?(id: number | string, motive: string): void;
  patchCloud?(field: string, value: any, id: number | string): void;
}

// initial state
const initialState = {
  cloud: null,
  updateLoading: false,
  errors: null,
};

// context
export const CloudDetailContext = createContext<CloudDetailState>(
  initialState as CloudDetailState,
);

// provider
export const CloudDetailProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <CloudDetailContext.Provider
      value={{
        // state
        cloud: state.cloud,
        updateLoading: state.updateLoading,
        errors: state.errors,

        // actions
        setLoading: value => setLoading(dispatch, value),
        getCloud: async id => await getCloud(dispatch, id),
        deleteCloud: async (id, motive) =>
          await deleteCloud(dispatch, id, motive),
        patchCloud: async (field, value, id) =>
          await patchCloud(dispatch, field, value, id),
      }}
    >
      {children}
    </CloudDetailContext.Provider>
  );
};
